export default __webpack_public_path__ + "static/media/curved-arrow.edc9f643.svg";